import { render } from "./Pagamento.vue?vue&type=template&id=2ebfea8c&scoped=true"
import script from "./Pagamento.vue?vue&type=script&lang=js"
export * from "./Pagamento.vue?vue&type=script&lang=js"

import "./Pagamento.vue?vue&type=style&index=0&id=2ebfea8c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebfea8c"]])

export default __exports__